import styled from 'styled-components';

export const StyledOTPInputContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
`;

export const StyledOTPInput = styled.input.attrs(props => ({
    type: 'text',
    maxLength: props.maxLength || '1',
    inputMode: 'numeric',
}))`
    width: 50px;
    height: 50px;
    border-radius: 100%;
    margin-right: 15px;
    font-size: 24px;
    border: 1px solid
        ${({ theme, isFocused, inputValue }) =>
            isFocused || inputValue
                ? theme.palette.primary.main
                : theme.palette.primary.inputBorder};
    background: transparent;
    text-align: center;
    color: ${({ theme }) => theme.palette.primary.text};
    &::placeholder {
        color: ${({ theme }) => theme.palette.primary.placeholder};
    }
    &:focus {
        outline: none;
    }
    /* Style to hide spinner arrows */
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield; /* Firefox */
    }

    &:last-child {
        margin-right: 0;
    }

    @media only screen and (max-width: 768px) {
        @supports (-webkit-touch-callout: none) {
            height: 60px;
        }
    }
`;
export const StyledResendTimer = styled.div`
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.placeholder};
`;

export const StyledResendText = styled.div`
    font-size: 22px;
    text-align: center;
    padding-top: 20px;
`;

export const StyledResendLink = styled.span`
    text-wrap: nowrap;
    font-weight: 500;
    a {
        margin-right: 0;
    }
    span {
        font-weight: 400;
        font-size: 18px;
    }
`;

export const StyledOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
`;

export const StyledDialog = styled.div`
    background: ${props => props.theme.palette.primary.modalContentBG};
    border-radius: 8px;
    width: 100%;
    margin: 40px;
    text-align: center;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    padding-top: 10px;
    font-size: 20px;
    max-width: 380px;
`;

export const StyledDialogContent = styled.div`
    color: #313131;
    line-height: 140%;
    padding: 10px 15px 15px;
    font-size: 20px;
`;

export const StyledActions = styled.div`
    display: flex;
    justify-content: center;
    gap: 1px;
`;

export const StyledActionButton = styled.button`
    background: ${props => props.theme.palette.primary.main};
    color: #fff;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    width: 100%;
    font-size: 20px;
    font-weight: 700;
    &:first-child {
        border-bottom-left-radius: 6px;
    }
    &:last-child {
        border-bottom-right-radius: 6px;
    }
    &:hover {
        opacity: 0.9;
    }
`;
